module.exports = __webpack_public_path__ + "static/media/Documents.be5e1700.svg";